import { render, staticRenderFns } from "./DesktopContentModal.vue?vue&type=template&id=6636e17e"
import script from "./DesktopContentModal.vue?vue&type=script&lang=js"
export * from "./DesktopContentModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports